import { reducer as tabMenuBar } from 'app/pages/AgentPricing/modules/TabMenuBar'
import { viewPageReducer as refData } from 'app/pages/AgentPricing/modules/RefData'
import { reducer as ratesTable } from 'app/pages/AgentPricing/modules/RatesTableWidget'
import { reducer as rateFinder } from 'app/pages/AgentPricing/modules/RateFinderWidget'
import { reducer as dialog } from 'app/pages/AgentPricing/modules/EditDialogs'
import { reducer as saveStatus } from 'app/pages/AgentPricing/modules/SaveStatus'
import { reducer as publishedVersions } from 'app/pages/AgentPricing/modules/PublishedVersions'

export const viewReducers = {
    tabMenuBar, 
    refData, 
    ratesTable, 
    rateFinder, 
    publishedVersions
};

export const editDiscountReducers = {
    refData,
    ratesTable,
    dialog,
    saveStatus
}